module.exports = __webpack_public_path__ + "img/help/layer-info.c21994b654273b33585927b7b2e84d4f.png";